import axios from 'src/app-axios';
import Constants from 'src/constants';

export const passcodereset = {
    namespaced: true,
    state: {
        linkActiveId: {},
    },
    getters: {
        getLinkActiveId (state) {
            return state.linkActiveId;
        },
    },
    mutations: {
        setLinkActiveId (state, data) {
            state.linkActiveId = data;
        },
        clearOffLinkActiveId (state) {
            state.linkActiveId = {};
        },
    },
    actions: {
        async confirmMobile ({ dispatch }, payload) {
            const url = 'api/devices/service-provider-updates/password/reset';
            try {
                await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in resetting your passcode.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async createLinkActiveId ({ dispatch, commit }, payload) {
            const url = 'api/devices/service-provider-updates/check';
            try {
                const response = await axios.post(url, payload);
                commit('setLinkActiveId', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in resetting your passcode.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async createNewPasscode ({ dispatch }, payload) {
            const url = 'api/devices/service-provider-updates/password/update';
            try {
                await axios.put(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your new passcode.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        clearLinkActiveId ({ commit }) {
            commit('clearOffLinkActiveId');
        },
    },
};
